<template>
  <div :class="wrapClasses">
    <template v-if="type !== 'textarea'">
      <div v-if="$slots.prepend" v-show="slotReady" :class="slotClass">
        <slot name="prepend"></slot>
      </div>
      <span v-if="icon" :class="iconClasses" @click="$_onIconClick">
        <t-icon :icon="icon"></t-icon>
        <!--<i :class="'aid-'+[icon]" class="aid"></i>-->
      </span>
      <div v-if="isGroup" :class="prefixCls">
        <input
          ref="input"
          v-model="model"
          :type="type"
          :class="inputClasses"
          :placeholder="placeholder"
          :disabled="disabled"
          :maxlength="maxlength>0?maxlength:''"
          :readonly="readonly"
          :name="name"
          :number="number"
          :autofocus="autofocus"
          :clearable="clearable"
          @keyup.enter="$_onEnter"
          @keyup="$_onKeyup"
          @keypress="$_onKeypress"
          @keydown="$_onKeydown"
          @focus="$_onFocus"
          @blur="$_onBlur"
          @input="$_onInput"
          @change="$_onChange"
        />
        <span v-if="isClear" :class="[prefixInputCls+'-close-icon']" @click="$_onClearIconClick">
          <t-icon icon="close-circle" class="text-muted"></t-icon>
          <!--<i class="aid aid-close-circle text-muted"></i>-->
        </span>
      </div>
      <input v-else
             ref="input"
             v-model="model"
             :type="type"
             :class="inputClasses"
             :placeholder="placeholder"
             :disabled="disabled"
             :maxlength="maxlength>0?maxlength:''"
             :readonly="readonly"
             :name="name"
             :number="number"
             :autofocus="autofocus"
             :clearable="clearable"
             @keyup.enter="$_onEnter"
             @keyup="$_onKeyup"
             @keypress="$_onKeypress"
             @keydown="$_onKeydown"
             @focus="$_onFocus"
             @blur="$_onBlur"
             @input="$_onInput"
             @change="$_onChange"
      />
      <span v-if="isClear && !isGroup" :class="[prefixInputCls+'-close-icon']" @click="$_onClearIconClick">
        <!--<i class="aid aid-close-circle"></i>-->
        <t-icon icon="close-circle"></t-icon>
      </span>
      <div v-if="$slots.append" v-show="slotReady" :class="slotClass">
        <slot name="append"></slot>
      </div>
    </template>
    <template v-else>
      <textarea
        ref="textarea"
        v-model="model"
        :class="textareaClasses"
        :style="textareaStyles"
        :placeholder="placeholder"
        :disabled="disabled"
        :rows="rows"
        :maxlength="maxlength>0?maxlength:''"
        :readonly="readonly"
        :name="name"
        :autofocus="autofocus"
        @keyup.enter="$_onEnter"
        @keyup="$_onKeyup"
        @keypress="$_onKeypress"
        @keydown="$_onKeydown"
        @focus="$_onFocus"
        @blur="$_onBlur"
        @input="$_onInput"
      >
      </textarea>
      <span v-if="count" :class="[prefixInputCls + '__count']">{{ countCurrent + '/' + maxlength }}</span>
    </template>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '@/utils/constants'
import { calcTextareaHeight } from '@/utils/assist'
import Emitter from '../../mixins/emitter'
const INPUT_PREFIX_CLASS = `${PREFIX_CLASS}input-wrapper`
const INPUT_PREFIX_TEXTAREA_CLASS = `${PREFIX_CLASS}input-textarea-wrapper`
const INPUT_PREFIX_INPUT_CLASS = `${PREFIX_CLASS}input`
const INPUT_PREFIX_INPUT_GROUP_CLASS = `${PREFIX_CLASS}input-group`
export default {
  name: 'TInput',
  mixins: [Emitter],
  props: {
    type: {
      type: String,
      validator(value) {
        /* istanbul ignore next */
        return ['text', 'textarea', 'password'].includes(value)
      },
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    size: {
      type: String,
      validator(value) {
        /* istanbul ignore next */
        return ['sm', 'lg', ''].includes(value)
      },
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number,
      default: -1
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    iconPlacement: {
      type: String,
      validator(value) {
        /* istanbul ignore next */
        return ['left', 'right'].includes(value)
      },
      default: 'left'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    rows: {
      type: Number,
      default: 2
    },
    readonly: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    number: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    count: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentValue: this.value,
      prefixCls: INPUT_PREFIX_CLASS,
      prepend: true,
      append: true,
      slotReady: false,
      prefixInputCls: INPUT_PREFIX_INPUT_CLASS,
      prefixTextCls: INPUT_PREFIX_TEXTAREA_CLASS,
      prefixIGCls: INPUT_PREFIX_INPUT_GROUP_CLASS,
      textareaStyles: {}
    }
  },
  computed: {
    model: {
      set (val) {
        if (this.type === 'textarea' && this.autosize) {
          this.$_resizeTextarea()
        }
        this.$emit('input', val)
      },
      get () {
        return this.value
      }
    },
    countCurrent: {
      get () {
        return this.value.toString().length || 0
      },
      set (val) {}
    },
    slotClass() {
      return this.prefixIGCls + ((this.$slots.prepend && /button/i.test(this.$slots.prepend[0].tag)) || (this.$slots.append && /button/i.test(this.$slots.append[0].tag)) ? '-btn' : '-addon')
    },
    isGroup() {
      return (
        this.prepend ||
        this.append ||
        this.icon
      )
    },
    wrapClasses() {
      if (this.type !== 'textarea') {
        if (!this.isGroup) {
          return this.prefixCls
        } else {
          return [
            `${this.prefixIGCls}`,
            {
              [`${this.prefixIGCls}--${this.size}`]:
                (this.prepend || this.append || this.icon) && !!this.size,
              [`${this.prefixIGCls}--disabled`]: this.disabled
            }
          ]
        }
      } else {
        return this.prefixTextCls
      }
    },
    inputClasses() {
      return [
        `${this.prefixInputCls}`,
        {
          [`${this.prefixInputCls}--${this.size}`]: !!this.size,
          [`${this.prefixInputCls}--disabled`]: this.disabled
        }
      ]
    },
    isClear () {
      return this.clearable && this.model && !this.disabled && !this.readonly
    },
    iconClasses() {
      return [
        `${this.prefixIGCls}-icon`,
        {
          [`${this.prefixIGCls}-icon--${this.iconPlacement}`]: this.iconPlacement
        }
      ]
    },
    textareaClasses() {
      return [
        `${this.prefixInputCls}`,
        {
          [`${this.prefixInputCls}--disabled`]: this.disabled
        }
      ]
    }
  },
  mounted() {
    if (this.type !== 'textarea') {
      this.prepend = this.$slots.prepend !== undefined
      this.append = this.$slots.append !== undefined
    } else {
      this.prepend = false
      this.append = false
    }
    this.slotReady = true
    this.$_resizeTextarea()
    /* istanbul ignore next */
    if (this.autofocus) {
      this.$nextTick(() => {
        this.focus()
      })
    }
  },
  methods: {
    focus() {
      /* istanbul ignore next */
      if (this.type === 'textarea') {
        this.$refs['textarea'].focus()
      } else {
        this.$refs['input'].focus()
      }
    },
    blur() {
      /* istanbul ignore next */
      if (this.type === 'textarea') {
        this.$refs['textarea'].blur()
      } else {
        this.$refs['input'].blur()
      }
    },
    $_onEnter(event) {
      this.$emit('enter', event)
    },
    $_onKeydown(event) {
      this.$emit('keydown', event)
    },
    $_onKeypress(event) {
      this.$emit('keypress', event)
    },
    $_onKeyup(event) {
      this.$emit('keyup', event)
    },
    $_onIconClick(event) {
      this.$emit('icon-click', event)
    },
    $_onFocus(event) {
      this.$emit('focus', event)
    },
    $_onBlur(event) {
      this.$emit('blur', event)
      // NOTE: 这种情况是不会存在的，因为是双向绑定
      if (this.value !== '' && this.model !== '' && this.value !== this.model) {
        // 针对使用修饰符，比如number修饰符导致的currentValue和value不一致
        this.$_setCurrentValue(this.value)
      }
      if (this.number && this.value && Number.isNaN(Number(this.value))) {
        let _val = this.value.replace(/[^0-9]/gi, '')
        // this.$emit('input', _val)
        this.$_setCurrentValue(_val)
      }
      this.dispatch('TFormItem', 'g-on-form-blur', this.model)
    },
    $_onInput(event) {
      let value = event.target.value
      if (this.number && value && value !== '-') {
        value = Number(value)
        if (Number.isNaN(value)) {
          value = this.model
          event.target.value = value
        }
      }
      // this.$emit('input', value)
      // this.$_setCurrentValue(value)
      this.$emit('input-change', event)
    },
    $_onChange(event) {
      this.$emit('change', event)
      this.dispatch('TFormItem', 'g-on-form-change', this.model)
    },
    $_setCurrentValue(value) {
      // NOTE: model和value一定是相等的
      // if (value === this.model) return
      this.model = value
      this.currentValue = value
      if (this.maxlength !== -1) {
        this.countCurrent = value.toString().length || 0
      }
    },
    $_resizeTextarea() {
      const autosize = this.autosize
      if (!autosize || this.type !== 'textarea') {
        return false
      }
      const minRows = autosize.minRows
      const maxRows = autosize.maxRows
      this.textareaStyles = calcTextareaHeight(
        this.$refs.textarea,
        minRows,
        maxRows
      )
    },
    $_onClearIconClick() {
      this.model = ''
      this.$emit('clear')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/input/input.vue